import * as React from 'react'
import { NumberFieldSeeker } from '@ui-seeker/core'

import { AppAntSwitch } from '@components'
import { isPreviousComparison, timeToCompare, yearlyComp } from '@signals'
import { Box } from '@mui/material'


export default function AppCommonFiltersPeriodCompareToggleButton({ ...props }) {
	return <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
		<AppAntSwitch
			falseText="Single period"
			trueText="Compare periods"
			checked={isPreviousComparison.value}
			onChange={e => {
				isPreviousComparison.value = e.target.checked
				if (!e.target.checked) {
					timeToCompare.value = ""
				}
			}}
			{...props}
		/>
		{isPreviousComparison.value && <AppAntSwitch
			trueText="Number of years"
			falseText="Number of days"
			checked={yearlyComp.value}
			onChange={e => yearlyComp.value = e.target.checked}
			{...props}
		/>}
	</Box>
}

export function AppCommonFiltersPeriodCompareInput({ ...props }) {
	return isPreviousComparison.value && <NumberFieldSeeker
		value={timeToCompare.value}
		onChange={e => timeToCompare.value = e.target.value}
		label="Days/Years compare"
		{...props}
	/>
}